import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class OutreachDesignatedMarketArea extends ApplicationRecord {
  static jsonapiType = "outreach_designated_market_areas";

  @Attr() dmaId: number;

  @Attr() name: string;
}

export default OutreachDesignatedMarketArea;
